import React, { useState } from 'react';

import { SmartChoice } from '../../../../../common/ProviderDetailTabs/About/SmartChoice';
import { useSaveRecommendationPreferences } from '../../../../../hooks/useSaveRecommendationPreferencesStatus/useSaveRecommendationPreferences';
import { FacilityDetails } from '../../../../../models/FacilityDetails';
import {
  ProviderDetails,
  ProviderType,
} from '../../../../../models/ProviderDetails';
import { InfoProvider } from '../../../../ProviderDetailTabs/ProviderLocationsDetails/InfoProvider';
import {
  ContentWrapper,
  InfoWrapper,
  LocationContainer,
} from './Locations.styled';
import { LocationsWidgetMapView } from './LocationsWidgetMapView';

type Props = {
  providerDetails: ProviderDetails | FacilityDetails;
  latitude: string;
  locationId?: string;
  longitude: string;
  setActiveTab?: (tab: string) => void;
  preferencesData?: any;
};

export const Locations = ({
  providerDetails,
  latitude,
  locationId,
  longitude,
  setActiveTab,
  preferencesData,
}: Props) => {
  const { providerLocations, providerType } = providerDetails;

  const [isPreferencesModalOpen, setPreferencesModalOpen] = useState(false);

  const [, saveRecommendationPreferences] = useSaveRecommendationPreferences({
    handleSuccess: () => {
      setPreferencesModalOpen(false);
    },
  });

  const findLocation = (loc) => loc.locationId === locationId;
  const passedLocation = locationId
    ? (providerLocations as any).find(findLocation)
    : undefined;
  const selectedLocation = passedLocation || providerLocations[0];
  const totalLocations = providerLocations.length;

  const type =
    providerType === ProviderType.ORGANIZATION ? 'facility' : 'provider';

  const isSmartChoiceWidget =
    providerType === ProviderType.ORGANIZATION &&
    selectedLocation?.recommendationDetails &&
    parseInt(
      selectedLocation?.recommendationDetails?.totalRecommendationScore || '0'
    ) > 0;

  return (
    <LocationContainer>
      <React.Fragment>
        {isSmartChoiceWidget && (
          <SmartChoice
            handleTabChange={() => setActiveTab?.('LOCATIONS')}
            isPreferencesModalOpen={isPreferencesModalOpen}
            isSuperUser
            locationKey={selectedLocation?.locationKey}
            preferencesData={preferencesData}
            providerDetails={providerDetails}
            recommendationDetails={selectedLocation?.recommendationDetails}
            saveRecommendationPreferences={saveRecommendationPreferences}
            setPreferencesModalOpen={setPreferencesModalOpen}
          />
        )}
        <ContentWrapper data-testid={`widget-info-${type}-wrapper`}>
          <LocationsWidgetMapView
            latitude={latitude}
            longitude={longitude}
            providerType={providerType}
            selectedLocation={selectedLocation}
            totalLocations={totalLocations}
          />
        </ContentWrapper>
        <ContentWrapper>
          <InfoWrapper>
            <InfoProvider
              providerDetails={providerDetails}
              selectedLocation={selectedLocation}
            />
          </InfoWrapper>
        </ContentWrapper>
      </React.Fragment>
    </LocationContainer>
  );
};
